import { Button, Modal } from '@ag1/ui';
import { StudioBaseImageV2 } from '@portal/shared/studio/StudioBaseImage/StudioBaseImage';
import { useShowV53Notification } from 'shared/hooks/useShowV53Notification';
import { useMedia } from 'state/context/MediaContext';
import { routes } from '../../../constants/routes';
import { useQueryGetCommonContentData } from '../../../state/studio/commonContentData/getCommonContentData';
import { useLocale } from '../../hooks/useLocale';
import styles from './ModalV53Notification.module.scss';
import { CloseModalIcon } from './components/CloseModalIcon';

export const ModalV53Notification = () => {
  const locale = useLocale();
  const { data: commonContent } = useQueryGetCommonContentData({ locale });
  const { isOpen, handleClose } = useShowV53Notification();
  const { atLarge } = useMedia();

  if (!isOpen || !commonContent?.v53NotificationModal) {
    return null;
  }

  const { title, subtitle, upgradedFormulaText, buttonText, imageMobile, imageDesktop } =
    commonContent?.v53NotificationModal ?? {};

  if (!title || !subtitle || !upgradedFormulaText || !buttonText || !imageMobile || !imageDesktop) {
    return null;
  }

  const renderStandardContent = () => {
    return (
      <Modal mode="center" isOpen={isOpen} onClose={handleClose} className={styles.modalStandard}>
        <Modal.Content hasFooter className={styles.standardContainer}>
          <div className={styles.topContainer}>
            <StudioBaseImageV2 className={styles.image} image={imageMobile} />
            <Button className={styles.closeIcon} onClick={handleClose} noPadding variant="link">
              <CloseModalIcon color="#FFFFFF" />
            </Button>
          </div>
          <div className={styles.bottomContainer}>
            <div className={styles.upgradedFormulaText}>{upgradedFormulaText}</div>
            <div className={styles.headingsArea}>
              <div className={styles.title}>{title}</div>
              <div className={styles.subtitle}>{subtitle}</div>
            </div>
            <Button size="small" rounded href={routes.nextGeneration} target="_blank">
              {buttonText}
            </Button>
          </div>
        </Modal.Content>
      </Modal>
    );
  };

  const renderLargeContent = () => {
    return (
      <Modal mode="center" isOpen={isOpen} onClose={handleClose} className={styles.modalLarge}>
        <Modal.Content hasFooter className={styles.containerLarge}>
          <div className={styles.leftContainer}>
            <StudioBaseImageV2 className={styles.image} image={imageDesktop} />
          </div>

          <div className={styles.rightContainer}>
            <Button
              className={styles.closeIcon}
              onClick={handleClose}
              noPadding
              variant="link"
              noWrap>
              <CloseModalIcon color="#0C3D3D" />
            </Button>
            <div className={styles.rightContainerBody}>
              <div className={styles.upgradedFormulaText}>{upgradedFormulaText}</div>
              <div className={styles.information}>
                <div className={styles.headingsArea}>
                  <div className={styles.title}>{title}</div>
                  <div className={styles.subtitle}>{subtitle}</div>
                </div>
                <Button
                  rounded
                  href={routes.nextGeneration}
                  target="_blank"
                  className={styles.button}>
                  {buttonText}
                </Button>
              </div>
            </div>
          </div>
        </Modal.Content>
      </Modal>
    );
  };

  return <>{atLarge ? renderLargeContent() : renderStandardContent()}</>;
};
